// Dify API 服务
import request from '@/utils/request';

/**
 * 会话管理 API
 */
export const conversationApi = {
    getConversations(params = {}) {
        return request.post('/chat/index', params);
    },

    renameConversation(conversationId, name, user) {
        return request.post(`/conversations/${conversationId}/name`, {
            name,
            user,
        });
    },

    autoGenerateTitle(conversationId, user) {
        return request.post(`/conversations/${conversationId}/name`, {
            auto_generate: true,
            user,
        });
    },
};

/**
 * 消息管理 API
 */
export const messageApi = {
    getMessages(params = {}) {
        return request.post('/chat/message_history', params);
    },
    message_history_column(params = {}) {
        return request.post('/chat/message_history_column', params);
    },

    sendMessage(params = {}) {
        return request.post('/chat/completions', params);
    },

    stopMessage(taskId, user) {
        return request.post(`/chat-messages/${taskId}/stop`, {
            user,
        });
    },

    feedbackMessage(messageId, rating, content = '', user) {
        return request.post(`/messages/${messageId}/feedbacks`, {
            rating,
            content,
            user,
        });
    },

    getSuggestedQuestions(messageId, user) {
        return request.get(`/messages/${messageId}/suggested`, {
            params: {
                user,
            },
        });
    },
};

/**
 * 应用信息 API
 */
export const appApi = {
    getAppInfo() {
        return request.get('/info');
    },

    getAppParameters() {
        return request.get('/parameters');
    },

    getAppMeta() {
        return request.get('/meta');
    },
};

/**
 * 文件上传 API
 */
export const fileApi = {
    uploadFile(file, user, onProgress) {
        const formData = new FormData();
        formData.append('file', file);
        formData.append('user', user);

        return request.post('/chat/upload_file', formData, {
            headers: {
                'Content-Type': 'multipart/form-data',
            },
            onUploadProgress: (event) => {
                if (event.total && onProgress) {
                    const percent = Math.round((event.loaded / event.total) * 100);
                    onProgress(percent);
                }
            },
        });
    },
};

// 默认导出所有 API
export default {
    conversation: conversationApi,
    message: messageApi,
    app: appApi,
    file: fileApi,
};
